<template>
  <div class="edit-link-box">
    <el-dialog
      title="结算账单"
      :visible.sync="dialogVisible"
      top="1%"
      width="88%"
      :before-close="handleClose"
      :close-on-click-modal="false"
      class="el-dialogs"
    >
      <div class="statSettlement-list-box">
        <!--操作栏-->
        <div class="action-bar">
          <el-date-picker
            v-model="time"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            @change="changeTime"
          ></el-date-picker>
          <el-input
            size="small"
            clearable
            placeholder="流水id"
            v-model="params.id"
             @change="getStatSettlementList('status')"
            class="param-input"
          />
          <el-select
            v-model="params.billType"
            clearable
            size="small"
            placeholder="交易类型"
            @change="getStatSettlementList('status')"
          >
            <el-option :value="1" label="收入"></el-option>
            <el-option :value="2" label="提现"></el-option>
            <el-option :value="3" label="退款"></el-option>
          </el-select>
          <el-button type="primary" size="small" @click="getStatSettlementList('status')">搜索</el-button>
        </div>
        <div class="price-box">总金额: {{sumYuan}}元</div>
        <!--数据表格-->
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column prop="id" label="id" align="center" min-width="220" fixed>
            <template slot-scope="scope">
              <span>{{scope.row.id }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="sumDate" label="日期" align="center" min-width="160">
            <template slot-scope="scope">
              <span>{{scope.row.sumDate | changeDate }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="districtCode" label="商区码" align="center" min-width="160">
            <template slot-scope="scope">
              <span>{{scope.row.districtCode}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="账号" align="center" min-width="160">
            <template slot-scope="scope">
              <span>{{scope.row.name }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="billType" label="交易类型" align="center" width="80">
            <template slot-scope="scope">
              <span>{{scope.row.billType | filterType }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="transNo" label="交易订单号" align="center" min-width="260">
            <template slot-scope="scope">
              <span>{{scope.row.transNo }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="yuan"
            show-overflow-tooltip
            label="人民币元"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span>{{scope.row.yuan }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="desc" label="记录描述" align="center" min-width="350">
            <template slot-scope="scope">
              <span>{{scope.row.desc }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createdAt" label="创建时间" align="center" min-width="180">
            <template slot-scope="scope">
              <span>{{scope.row.createdAt | changeDate}}</span>
            </template>
          </el-table-column>
        </el-table>
        <div style="withd:500px">
          <el-pagination
            :page-sizes="[10, 15, 20, 25]"
            :current-page="params.pageNumber"
            :page-size="params.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
            @size-change="changeSize"
            @current-change="changeCurrent"
          ></el-pagination>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" style="height:80px"></div>
    </el-dialog>
  </div>
</template>
<script>
import { changeTime } from "@/utils/global";
import API from "@/api";
export default {
  data() {
    return {
      //  currentPage4: 4,
      title: "结算账单",
      tableData: [],
      time: "",
      loading: false,
      sumYuan: 0,
      total: 0,
      // 请求订单列表参数
      index: 0,
      // 外层弹出框
      dialogVisible: false,
      // 提交按钮状态
      flag: false,
      // 编辑链接参数
      params: {
        pageNumber: 1,
        pageSize: 10,
        id: "", //流水id
        billType: "", //用户UID
        startTime: "",
        endTime: "",
        discCode: "" //商区码
      }
    };
  },
  filters: {
    filterType(params) {
      switch (params) {
        case 1:
          return "收入";
        case 2:
          return "提现";
        case 3:
          return "退款";
        default:
          return "未知";
      }
    }
  },
  methods: {
    // 请求订单列表
    getStatSettlementList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      this.loading = true;
      API.getStatSettlementList(this.params)
        .then(res => {
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list;
            this.total = res.data.total;
            this.sumYuan = res.data.sumYuan;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getStatSettlementList();
    },
    // 分页页码改变回调
    changeCurrent(number) {
      this.params.pageNumber = number;
      this.getStatSettlementList();
    },
    // 时间选择回调
    changeTime(time) {
      if (time) {
        this.params.startTime = changeTime(time[0]) || "";
        this.params.endTime = changeTime(time[1]) || "";
      } else {
        this.params.startTime = "";
        this.params.endTime = "";
      }
      this.getStatSettlementList("status");
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        pageNumber: 1,
        pageSize: 10,
        id: "", //流水id
        billType: "", //用户UID
        startTime: "",
        endTime: "",
        discCode: "" //商区码
      };
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(row) {
      this.dialogVisible = true;
      this.params.agent = row.agent;
      this.params.discCode = row.districtCode;
      this.getStatSettlementList();
    }
  }
};
</script>
<style lang="scss">
.statSettlement-list-box {
  .icon {
    font-size: 16px;
    margin-left: 10px;
    cursor: pointer;
    color: #e63765;
    vertical-align: middle !important;
    &:hover {
      color: #eb5f84;
    }
  }
  .zw {
    height: 100px;
  }
  .price-box {
    font-size: 16px;
  }
}
</style>

